"use client";

import Link from "next/link";
import { useAuth } from "@/contexts/AuthContext";

type NavbarAuthProps = {
  className?: string;
};

export default function NavbarAuth({ className = "" }: NavbarAuthProps) {
  const { isLoggedIn, logout } = useAuth();

  if (!isLoggedIn) {
    return (
      <Link href="/login" className={`navbar-button ${className}`.trim()} style={{ textDecoration: "none" }}>
        Login
      </Link>
    );
  }

  return (
    <button
      onClick={logout}
      className={`navbar-button navbar-button--danger ${className}`.trim()}
    >
      Logout
    </button>
  );
}
